// terms.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebButtonModule } from '../web-button/web-button.module';

import { TermsComponent } from './terms.component';

@NgModule({
  declarations: [TermsComponent],
  imports: [CommonModule, WebButtonModule],
  exports: [TermsComponent],
})
export class TermsModule {}
